import * as React from 'react';
import { GridCell } from '@progress/kendo-react-grid';
import { Link } from 'react-router-dom';
import { DeleteModuleContext } from './../common/context';
import { IconButton } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import RateReviewIcon from '@material-ui/icons/RateReview';

export default class EditModuleButton extends GridCell {
    constructor(props: any) {
        super(props);

    }

    render() {
        return (
            <DeleteModuleContext.Consumer>
                {(value: any) => {
                    return (
                        <>
                            <td className="actions editModule">
                                <Link to={{ pathname: `/module/${this.props.dataItem.id}` }}>
                                    <IconButton className="EditItem" title="Edit Module">
                                        <EditIcon />
                                    </IconButton>
                                </Link>
                                <Link to={{ pathname: `/preview/${this.props.dataItem.id}` }}>
                                    <IconButton className="PreviewItem" title="Preview Module">
                                        <VisibilityIcon />
                                    </IconButton>
                                </Link>
                                {
                                    this.props.dataItem.show_review_icon &&
                                    <Link to={{ pathname: `/reviewQuestions/${this.props.dataItem.id}` }}>
                                        <IconButton className="PreviewItem" title="Review Questions">
                                            <RateReviewIcon />
                                        </IconButton>
                                    </Link>
                                }
                                {
                                    !this.props.dataItem.show_review_icon &&
                                    <Link to={{}}>
                                        <IconButton className="PreviewItem" title="Review Questions" disabled={true}>
                                            <RateReviewIcon color='disabled'/>
                                        </IconButton>
                                    </Link>
                                }
                            </td>
                        </>
                    )
                }}
            </DeleteModuleContext.Consumer>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/modules/EditModuleButton.tsx